import { Controller } from "@hotwired/stimulus";

// Animates a layout C flash toast out when its close button is pressed, matching
// the `oc-flash-exit` animation used by auto-dismissing timed toasts. Attached to
// each `.oc-flash` element so it works on every page that renders the layout C
// flash stack (menu, payment), independent of the ordering-layout controller.
export default class extends Controller {
  // data-oc-autohide-ms lives here rather than in ordering-layout: that controller is only
  // mounted on the menu, so error toasts on the payment/charge/success pages had nothing to
  // time them out and sat over the checkout summary until dismissed by hand. Bootstrap's own
  // data-bs-autohide never fires either — it's only armed inside Toast.show(), and these toasts
  // are rendered with .show already on them, so show() is never called.
  connect() {
    const delay = parseInt(this.element.dataset.ocAutohideMs, 10);
    if (isNaN(delay) || delay <= 0) return;

    this.autohideTimer = setTimeout(() => this.dismiss(), delay);
  }

  disconnect() {
    clearTimeout(this.autohideTimer);
  }

  dismiss() {
    const toast = this.element;
    if (toast.classList.contains("fade-out")) return;
    toast.classList.add("fade-out");

    const remove = (event) => {
      if (event.target !== toast || event.animationName !== "oc-flash-exit") return;
      toast.remove();
    };
    toast.addEventListener("animationend", remove);
    // Fallback for reduced-motion / interrupted animations.
    setTimeout(() => toast.remove(), 400);
  }
}
